import ImagemCarregando from "../../../components/ImagemCarregando";
import localizacao_icon from "../../../../assets/icons/localizacao.svg";
import especie_icon from "../../../../assets/icons/especie.svg";
import data_icon from "../../../../assets/icons/data.svg";
import profile_icon from "../../../../assets/icons/profile.svg";
import arrow_rigth_icon from "../../../../assets/icons/arrow-right.svg";
import arrow_left_icon from "../../../../assets/icons/arrow-left.svg";
import { formatData } from "../../../../utils/conversoes";
import { areaEmHectares, formatarArea } from "../../../../utils/geometria";
import MapaAreaLeitura from "../../../components/MapaAreaLeitura";

const nomeEspecie = (item) => item?.especie?.nome_comum || item?.especie?.nome_cientifico || "Espécie sem nome";

function InformacoesPlantio({ plantio, previousImage, nextImage }) {
  const midias = plantio?.midias || [];
  const especies = plantio?.especies || [];
  const totalMudas = especies.reduce((soma, e) => soma + (Number(e.numero_mudas) || 0), 0);
  const ehArea = plantio?.tipo_categoria === "Profissional";
  const local = [plantio?.cidade, plantio?.estado].filter(Boolean).join(" / ");
  const hectares = ehArea ? areaEmHectares(plantio?.coordenadas) : 0;

  return (
    <div className="corpo">
      <section className="coluna-galeria" aria-label="Fotos do plantio">
        <div className="gallery">
          <div className="images">
            {midias.length === 0 &&
              <div className="image sem-midia"><span>Este plantio não tem fotos.</span></div>
            }
            {midias.map((midia) => (
              <div className="image" key={midia.id}>
                {midia.tipo === "Imagem"
                  ? <ImagemCarregando src={`${midia.path}`} alt={`Foto do plantio ${plantio.titulo || plantio.id}`} />
                  : <video src={`${midia.path}`} controls title={`Vídeo do plantio ${plantio.titulo || plantio.id}`} />}
              </div>
            ))}
          </div>

          {midias.length > 1 &&
            <>
              <div className="previus">
                <button type="button" onClick={previousImage} aria-label="Foto anterior">
                  <img src={arrow_left_icon} alt="" />
                </button>
              </div>
              <div className="next">
                <button type="button" onClick={nextImage} aria-label="Próxima foto">
                  <img src={arrow_rigth_icon} alt="" />
                </button>
              </div>
            </>
          }
        </div>
        {midias.length > 1 && <span className="contagem-fotos">{midias.length} fotos</span>}

        {ehArea && (plantio.coordenadas?.length || 0) >= 3 &&
          <div className="bloco-mapa-area">
            <span className="rotulo">Área marcada no mapa</span>
            <MapaAreaLeitura coordenadas={plantio.coordenadas} />
          </div>
        }
      </section>

      <section className="info coluna-info">
        <div className="titulo-plantio">
          <h2 id="plantio-titulo">{plantio.titulo || `Plantio ${plantio.id}`}</h2>
          <span className={`selo ${ehArea ? "area" : "individual"}`}>{ehArea ? "Área" : "Individual"}</span>
        </div>

        <div className="grade-info">
          <div className="item">
            <img src={data_icon} alt="" />
            <div><span className="rotulo">Data do plantio</span><span className="details">{formatData(plantio.data)}</span></div>
          </div>

          <div className="item">
            <img src={profile_icon} alt="" />
            <div><span className="rotulo">Tipo de plantação</span><span className="details">{plantio.tipo}{plantio.nome_organizacao ? ` · ${plantio.nome_organizacao}` : ""}</span></div>
          </div>

          <div className="item largo">
            <img src={localizacao_icon} alt="" />
            <div>
              <span className="rotulo">Localização</span>
              <span className="details">{plantio.endereco || "Endereço não informado"}</span>
              {local && <span className="details secundario">{local}</span>}
            </div>
          </div>

          {ehArea && (plantio.coordenadas?.length || 0) > 0 &&
            <div className="item largo destaque-area">
              <img src={localizacao_icon} alt="" />
              <div>
                <span className="rotulo">Tamanho da área</span>
                <span className="details area-valor">{formatarArea(hectares)}</span>
                <span className="details secundario">Aproximado, a partir dos {plantio.coordenadas.length} pontos marcados no mapa</span>
              </div>
            </div>
          }
        </div>

        <div className="bloco-especies">
          <div className="cabecalho-especies">
            <img src={especie_icon} alt="" />
            <span className="rotulo">Espécies plantadas</span>
            <span className="total-mudas">{totalMudas} {totalMudas === 1 ? "muda" : "mudas"}</span>
          </div>
          <ul className="lista-especies">
            {especies.length === 0 && <li className="vazio">Nenhuma espécie informada.</li>}
            {especies.map((item, i) => (
              <li key={`${item.especie?.id ?? "e"}-${i}`}>
                <span className="nome">
                  {nomeEspecie(item)}
                  {item.especie?.nome_comum && item.especie?.nome_cientifico && <em>{item.especie.nome_cientifico}</em>}
                </span>
                <span className="mudas">{item.numero_mudas} {Number(item.numero_mudas) === 1 ? "muda" : "mudas"}</span>
              </li>
            ))}
          </ul>
        </div>
      </section>
    </div>
  );
}

export default InformacoesPlantio;
